// extracted by mini-css-extract-plugin
export default {"container":"style_container__sOSrE","title":"style_title__IBqc9","divider":"style_divider__qcw5l","formFooter":"style_formFooter__nbWjZ"};